import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactSajatUtamonContent from '@/components/contact/ContactSajatUtamonContent'

export default function ContactSajatUtamon() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - A saját utamon | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés a Saját utamon művészetterápiás csoportba" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/sajat-utamon" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Saját utamon) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés a &quot;Saját utamon&quot; művészetterápiás csoportba"
          hidden="sajat-utamon"
          content={<ContactSajatUtamonContent />}
        >
          <img
            src={`${config.basePath}/images/sajat-utamon-infinite.png`}
            alt="A saját utamon"
            width={"100%"}
          />
        </Contact>
      </section>
      
      <div className="mx-auto w-3/4 mb-8">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
